<template>
    <header class="container-fluid shadow-sm">
        <div class="row align-items-center p-2">
            <div id="logo-container" class="col d-flex">
                <b-link :to="'/'">
                    <img :src="logo.source" :alt="logo.alt" />
                </b-link>
            </div>

            <div class="col-auto d-none d-sm-flex">
                <b-button class="btn btn-dark d-flex align-items-center mr-3" v-b-modal.domiciliation-help-modal>
                    <img :src="question.classic" alt="Point d'interrogation" width="20" height="20" class="mr-2">
                    Aide
                </b-button>

                <a :href="'tel:' + phone.num">
                    <b-button class="btn btn-dark d-flex align-items-center" v-b-modal.contact-modal>
                        <img :src="phone.classic" alt="Téléphone" width="20" height="20" class="mr-2">
                        {{ phone.num }}
                    </b-button>
                </a>
            </div>

            <div class="col-auto d-flex d-sm-none">
                <b-button class="bg-transparent border-0 mr-3" v-b-modal.domiciliation-help-modal>
                    <img :src="question.filled" alt="Point d'interrogation" width="30" height="30">
                </b-button>

                <b-button class="bg-transparent border-0" v-b-modal.contact-modal>
                    <img :src="phone.filled" alt="Téléphone" width="25" height="25">
                </b-button>
            </div>
        </div>
    </header>
</template>

<script>
    export default {
        data() {
            return {
                logo: {
                    source: require("@/assets/images/assistel.png"),
                    alt: "Logo de Assistel"
                },
                question: {
                    classic: require("@/assets/images/icons/question/question.svg"),
                    filled: require("@/assets/images/icons/question/question-filled.svg")
                },
                phone: {
                    classic: require("@/assets/images/icons/phone/phone.svg"),
                    filled: require("@/assets/images/icons/phone/phone-filled.svg"),
                    num: "01 39 23 65 65"
                }
            }
        }
    }
</script>

<style lang="scss">
    a:hover
    {
        text-decoration: none !important;
    }
</style>
